import {ViewerInfo} from '../../../../../../graphql/generated/types';
import {AppState} from '../../../../../../state/store';

export const selectTalkViewerState = (state: AppState) => state.talkViewer;

export const selectViewerMenuState = (state: AppState) => state.viewerMenu;

export const selectViewerEndState = (state: AppState) => state.viewerEnd;

export const selectViewerInfoState = (state: AppState) => state.viewerInfo;

export const selectCanShowViewerEnd = (
  state: AppState,
  viewerInfoData?: ViewerInfo
) => {
  // 다음작품이 없으면 무조건 뷰어엔드로 넘어갑니다.
  if (!viewerInfoData?.nextItem) {
    return true;
  }
  if (state.viewerInfo.currentSeriesId) {
    return !state.viewerInfo.nonstopWatchingInSeries[
      state.viewerInfo.currentSeriesId
    ]?.isNonstopWatching;
  } else {
    return true;
  }
};
